import { render } from "./index.vue?vue&type=template&id=6c8c2604&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6c8c2604&scoped=true&lang=css"

import exportComponent from "/Users/bart/Project/vue/GutsHairCutting_ReservationSystem/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8c2604"]])

export default __exports__